import dayjs from "dayjs";
import * as yup from "yup";

export const emptylocalizacaoCarga = {
  cidade: "",
  estado: "",
  localizacao: "",
  quantidade: null,
};

export const emptyDetalheLoteDto = {
  // id: "",
  // inicial:true,
  // gtinEan: "",
  // sku: "",
  // descricao: "",
  // categoria: "",
  // lote: "",
  // unidades: 0,
  // urlImagens: "",
  // quantidadePorCaixa: "",
  // caixaPallet: "",
  // loteMinimo: "",
  // tipoFrete: "",
  // precoUnidade: null,
  // quantidadeTotalPallets: null,
  // valorSubstTributaria: null,
  // estoqueDisponivelCaixas: "",
  // pedidoMinimo: null,
  // precoVenda_NF_PorCaixa: "",
  // feeGreeners: "",
  // feeGreenersPrecoMedioVarejo: "",
  // markup: 0,
  // precoUnitarioFee: 0,
  // valorEconomia: 0,
  // descontoAplicado: "",
  // observacoes: "",
  // motivoOferta: "",
  // outro: "",
  // oportunidadeId: "",
  // dataValidade: null,
  // localizacaoCarga: [emptylocalizacaoCarga],
};

export const formOportunidadeValidator = (statusDeal) => {
  return yup.object().shape({
    statusDeal: yup.string().required("Campo obrigatório"),
    dadosEmpresaSellerId: yup.string().required("Campo obrigatório"),
    detalheLoteDto: yup.array().of(
      yup.object().shape({
        gtinEan:
          statusDeal !== 1
            ? yup.string().required("Campo obrigatório")
            : yup.string(),
        motivoOferta:
          statusDeal !== 1
            ? yup
                .string()
                .transform((value) => (value === null ? "" : value))
                .required("Campo obrigatório")
            : yup.string().transform((value) => (value === null ? "" : value)),
            outro: yup.string().when("motivoOferta", {
          is: (motivoOferta) => motivoOferta === "Outro",
          then: yup.string().required("Campo obrigatório"),
          otherwise: yup.string(),
        }),
        pedidoMinimo: yup
          .number()
          .min(0, "Não é permitido números negativos")
          .nullable(),
        estoqueDisponivelCaixas:
          statusDeal !== 1
            ? yup
                .number()
                .transform((value) => (isNaN(value) ? undefined : value))
                .min(0, "Não é permitido números negativos")
                .required("Campo obrigatório")
            : yup
                .number()
                .transform((value) => (isNaN(value) ? undefined : value))
                .min(0, "Não é permitido números negativos"),
        precoVenda_NF_PorCaixa:
          statusDeal !== 1
            ? yup
                .string()
                .transform((value) => (value === null ? "" : value))
                .required("Campo obrigatório")
            : yup.string().transform((value) => (value === null ? "" : value)),
        feeGreeners:
          statusDeal !== 1
            ? yup
                .number()
                .transform((value) => (isNaN(value) ? undefined : value))
                .required("Campo obrigatório")
            : yup.number().notRequired().nullable(),
        feeGreenersPrecoMedioVarejo:
          statusDeal !== 1
            ? yup
                .number()
                .transform((value) => (isNaN(value) ? undefined : value))
                .required("Campo obrigatório")
            : yup.number().notRequired().nullable(),
        // localizacaoCarga: yup.array().of(
        //   yup.object().shape({
        //     quantidade:
        //       statusDeal !== 1
        //         ? yup
        //             .number()
        //             .transform((value) => (isNaN(value) ? undefined : value))
        //             .min(0, "Não é permitido números negativos")
        //             .required("Campo obrigatório")
        //         : yup
        //             .number()
        //             .transform((value) => (isNaN(value) ? null : value))
        //             .min(0, "Não é permitido números negativos")
        //             .nullable(),
        //   })
        // ),
      })
    ),
  });
};

export const formOportunidadeInitialState = () => ({
  dataAbertura: new Date(),
  codigo: "",
  statusDeal: 1,
  motivoOferta: "",
  statusOferta: "",
  tipoOportunidade: "",
  totalSKU: 1,
  dadosEmpresaSellerId: "",
  nomeFantasia: "",
  vendedor: "",
  userId: "",
  detalheLoteDto: new Array(emptyDetalheLoteDto),
  nomeOportunidade: "",
  linkOportunidade: "",
  linkOportunidade: "",
  taxaST:"",
  feeGreeners:"",
  feeOperLog:"",
  tp: "",
  dataAtualizacao: null,
});

export const mapearData = (oportunidade, localizacaoCarga) => {
  let data = {
    codigo: oportunidade.codigo,
    dataAbertura: oportunidade.dataAbertura,
    motivoOferta: oportunidade.motivoOferta,
    statusDeal: oportunidade.statusDeal,
    statusOferta: oportunidade?.statusOferta,
    tipoOportunidade: oportunidade?.tipoOportunidade,
    userId: oportunidade.userId,
    dadosEmpresaSellerId: oportunidade.dadosEmpresaSellerId,
    urlImagens: oportunidade.urlImagens,
    linkOportunidade: oportunidade.linkOportunidade,
    taxaST: oportunidade.taxaST,
    feeGreeners: oportunidade.feeGreeners,
    feeOperLog: oportunidade.feeOperLog,
    tp: oportunidade.tp,
    dataAtualizacao: oportunidade.dataAtualizacao,

    detalheLoteDto:
      oportunidade.gtinEan != ""
        ? {
            gtinEan: oportunidade.gtinEan,
            sku: oportunidade.sku,
            descricao: oportunidade.descricao,
            categoria: oportunidade.categoria,
            lote: oportunidade.lote,
            unidades: oportunidade.unidades,
            urlImagens: oportunidade.urlImagens,
            quantidadePorCaixa: oportunidade.quantidadePorCaixa,
            peso: oportunidade.peso,
            dimessaoCaixa: oportunidade.dimessaoCaixa,
            caixaPallet: oportunidade.caixaPallet,
            loteMinimo: oportunidade.loteMinimo,
            lote:oportunidade.lote,
            tipoFrete: oportunidade.tipoFrete,
            precoUnidade: oportunidade.precoUnidade,
            precoDisplay: oportunidade.precoDisplay,
            precoCaixa: oportunidade.precoCaixa,
            precoConsumidor: oportunidade.precoConsumidor,
            precoTotalLote: oportunidade.precoTotalLote,
            precoMinimo: oportunidade.precoMinimo,
            descontoMaximo: oportunidade.descontoMaximo,
            markup: oportunidade.markup,
            precoUnitarioFee: oportunidade.precoUnitarioFee,
            valorEconomia: oportunidade.valorEconomia
            /*,
                    gpc: oportunidade.gpc,//novos campos
                    ncm: oportunidade.ncm,
                    marca: oportunidade.marca,
                    fabricante: oportunidade.fabricante,
                    quantidade: oportunidade.quantidade,
                    altura: oportunidade.altura,
                    pesoBruto: oportunidade.pesoBruto,
                    alturaPorCaixa: oportunidade.alturaPorCaixa,
                    larguraPorCaixa: oportunidade.larguraPorCaixa,
                    profundidadePorCaixa: oportunidade.profundidadePorCaixa,
                    pesoBrutoPorCaixa: oportunidade.pesoBrutoPorCaixa,
                    alturaPorPallet: oportunidade.alturaPorPallet,
                    larguraPorPallet: oportunidade.larguraPorPallet,
                    profundidadePorPallet: oportunidade.profundidadePorPallet,
                    pesoBrutoPorPallet: oportunidade.pesoBrutoPorPallet,
                    pesoLiquidoPorPallet: oportunidade.pesoLiquidoPorPallet,
                    volumePorPallet: oportunidade.volumePorPallet,
                    validadeLote: oportunidade.validadeLote,
                    validadeLoteDias: oportunidade.validadeLoteDias,
                    quantidadePallet: oportunidade.quantidadePallet,
                    pesoTotal: oportunidade.pesoTotal,
                    pesoMinimo: oportunidade.pesoMinimo,
                    frete: oportunidade.frete,
                    precoTabelaUnidade: oportunidade.precoTabelaUnidade,
                    precoTabelaDisplay: oportunidade.precoTabelaDisplay,
                    precoTabelaCaixa: oportunidade.precoTabelaCaixa,
                    precoSugeridoCaixa: oportunidade.precoSugeridoCaixa,
                    precoPorCaixaSemImpostos: oportunidade.precoPorCaixaSemImpostos,
                    impostosPorCaixa: oportunidade.impostosPorCaixa,
                    valorPorCaixaNF: oportunidade.valorPorCaixaNF,
                    descontoAplicado: oportunidade.descontoAplicado,
                    feeGreeners: oportunidade.feeGreeners,
                    feeGreenersPorCaixa: oportunidade.feeGreenersPorCaixa,
                    markupCaixa: oportunidade.markupCaixa,
                    markupUnidade: oportunidade.markupUnidade,
                    precoTotalLote: oportunidade.precoTotalLote
                    */
          }
        : null,
    localizacaoCarga: localizacaoCarga != null ? localizacaoCarga : null,
  };

  return data;
};

export const mapDataToSent = (values) => ({
  id: values?.id || undefined,
  codigo: values?.codigo,
  dataAbertura: dayjs().format("YYYY-MM-DD"),
  descricaoNcm: values?.ncm,
  statusDeal: values?.statusDeal,
  motivoOfertaId: values?.motivoOferta,
  statusOfertaId: values?.statusOferta,
  tipoOportunidade: values?.tipoOportunidade,
  dadosEmpresaSellerId: values?.dadosEmpresaSellerId,
  nomeOportunidade: values?.nomeOportunidade,
  linkOportunidade: values?.linkOportunidade,
  taxaST: values?.taxaST,
  feeGreeners: values?.feeGreeners,
  feeOperLog: values?.feeOperLog,
  tp: values?.tp,
  produtoOportunideResponseDto: undefined,
  userId: values?.userId || undefined,
  dataAtualizacao: values.dataAtualizacao,

  detalheLoteDto: values?.detalheLoteDto?.map((detalheLoteDto) => {
    
    return {
      id: detalheLoteDto?.id || undefined,
      gtinEan: detalheLoteDto?.gtinEan,
      sku: detalheLoteDto?.sku || "",
      gpc: detalheLoteDto?.gpc || "",
      descricao: detalheLoteDto?.descricao,
      categoria: detalheLoteDto?.categoria,
      lote: detalheLoteDto?.lote || "",
      unidades: detalheLoteDto?.unidades
        ? Number(detalheLoteDto?.unidades)
        : undefined,
      urlImagens: detalheLoteDto?.urlImagens,
      quantidadePorCaixa: detalheLoteDto?.quantidadePorCaixa
        ? Number(detalheLoteDto?.quantidadePorCaixa)
        : undefined,
      peso: detalheLoteDto?.peso,
      dimessaoCaixa: detalheLoteDto?.dimessaoCaixa,
      caixaPallet: detalheLoteDto?.caixaPallet,
      loteMinimo: detalheLoteDto?.loteMinimo,
      tipoFrete: detalheLoteDto?.tipoFrete,
      precoUnidade: detalheLoteDto?.precoUnidade
        ? Number(detalheLoteDto?.precoUnidade)
        : undefined,
      precoDisplay: detalheLoteDto?.precoDisplay
        ? Number(detalheLoteDto?.precoDisplay)
        : undefined,
      precoCaixa: detalheLoteDto?.precoCaixa
        ? Number(detalheLoteDto?.precoCaixa)
        : undefined,
      precoConsumidor: detalheLoteDto?.precoConsumidor
        ? Number(detalheLoteDto?.precoConsumidor)
        : undefined,
      precoTotalLote: detalheLoteDto?.precoTotalLote
        ? Number(detalheLoteDto?.precoTotalLote)
        : undefined,
      precoMinimo: detalheLoteDto?.precoMinimo
        ? Number(detalheLoteDto?.precoMinimo)
        : undefined,
      descontoMaximo: detalheLoteDto?.descontoMaximo
        ? Number(detalheLoteDto?.descontoMaximo)
        : undefined,
      estoqueDisponivelCaixas: detalheLoteDto?.estoqueDisponivelCaixas
        ? Number(detalheLoteDto?.estoqueDisponivelCaixas)
        : undefined,
      pedidoMinimo: detalheLoteDto?.pedidoMinimo
        ? Number(detalheLoteDto?.pedidoMinimo)
        : undefined,
      estadoDestino: detalheLoteDto?.estadoDestino || undefined,
      valorSubstTributaria: detalheLoteDto?.valorSubstTributaria
        ? Number(detalheLoteDto?.valorSubstTributaria)
        : undefined,
      precoVenda_NF_PorCaixa: detalheLoteDto?.precoVenda_NF_PorCaixa
        ? Number(detalheLoteDto?.precoVenda_NF_PorCaixa)
        : undefined,
      observacoes: detalheLoteDto?.observacoes,
      motivoOfertaId:  detalheLoteDto?.motivoOferta,
      outro: detalheLoteDto?.outro,
      dataValidade: detalheLoteDto?.dataValidade,
      descontoAplicado: detalheLoteDto?.descontoAplicado,
      feeGreenersPrecoMedioVarejo: detalheLoteDto?.feeGreenersPrecoMedioVarejo,
      markup: detalheLoteDto?.markup,
      precoUnitarioFee: detalheLoteDto?.precoUnitarioFee,
      valorEconomia: detalheLoteDto?.valorEconomia,
      feeGreeners: detalheLoteDto?.feeGreeners
        ? Number(detalheLoteDto?.feeGreeners)
        : undefined,
      localizacaoCarga: detalheLoteDto?.localizacaoCarga.map((localizacaoCarga) => ({
        id: localizacaoCarga?.id || undefined,
        localizacao: localizacaoCarga?.localizacao,
        cidade: localizacaoCarga?.cidade,
        estado: localizacaoCarga?.estado,
        quantidade: localizacaoCarga?.quantidade
          ? Number(localizacaoCarga?.quantidade)
          : undefined,
      }))
    };
  }),
});
